// @flow
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import type { Dispatch } from "redux"
import Textarea from "@kiwicom/orbit-components/lib/Textarea"
import Button from "@kiwicom/orbit-components/lib/Button"

const FlexWrapper = styled.div`
  display: flex;
`

const ButtonWrapper = styled.div`
  margin: auto 0 0 0;
`

const IsJsonString = str => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

type Props = {
  dispatch: Dispatch<any>,
  splitster: Object, // eslint-disable-line flowtype/no-weak-types
}

type State = {
  splitsterConfig: string,
}

class SaveLoadSplitster extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      splitsterConfig: JSON.stringify(props.splitster.getSaveResults()),
    }
  }

  setSplitster = () => {
    const {
      props: { dispatch },
      state: { splitsterConfig },
    } = this
    try {
      const cfg = JSON.parse(splitsterConfig)
      const entries = Object.entries(cfg)
      entries.forEach(([testId, variantId]) =>
        dispatch({ type: "splitster/SET", payload: { testId, variantId, cookies: true } }),
      )
    } catch (err) {
      console.error(err)
    }
  }

  changeSplitsterConfig = (e: SyntheticInputEvent<*>) => {
    this.setState({ splitsterConfig: e.target.value })
  }

  render() {
    return (
      <>
        <h4>Copy/Paste tests setting</h4>
        <FlexWrapper>
          <Textarea
            size="small"
            value={this.state.splitsterConfig}
            onChange={this.changeSplitsterConfig}
            dataTest="splitster-config"
            help={!IsJsonString(this.state.splitsterConfig) ? "invalid JSON" : ""}
          />
          <ButtonWrapper>
            <Button
              onClick={this.setSplitster}
              block={false}
              type="primary"
              size="normal"
              disabled={!IsJsonString(this.state.splitsterConfig)}
            >
              Set
            </Button>
          </ButtonWrapper>
        </FlexWrapper>
      </>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(state => ({
  splitster: state.splitster,
}))(SaveLoadSplitster)
